var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFydLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg891",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 536.47 600"
    },
    viewBox: "0 0 536.47 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style876"
  }, ".st4{fill-rule:evenodd;clip-rule:evenodd;fill:#1a1a1a}")), /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path878",
    d: "m270.51 40.71 111.36 64.3 111.36 64.29v257.17l-111.36 64.3-111.36 64.29-111.36-64.29-111.36-64.3V169.3l111.36-64.29z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9f9f9",
      stroke: "#353535",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path880",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2c2c2c"
    },
    d: "M478.8 263.04V415.9l-104.14 62.74-104.14 62.74-104.14-62.74L62.23 415.9V178.22h43.03l43.03 84.82h244.46l43.03-84.82h43.03v84.82h-.01zm-366.63 68.59-5.25 16.27-17.1-.03 13.85 10.03-5.32 16.25 13.82-10.08 13.82 10.08-5.32-16.25 13.85-10.03-17.1.03-5.25-16.27zm195.56 121.91h43.05c17.65 0 26.48-7.98 26.48-23.94V320.02c0-21.18-10.36-31.77-31.08-31.77h-38.45v165.29zm22.1-20.03h16.58c5.83 0 8.75-2.46 8.75-7.37v-105.9c0-7.98-3.3-11.97-9.9-11.97h-15.42v125.24h-.01zm-58.28 20.03v-60.78l26.71-104.52h-21.87l-14.96 71.83h-.69l-16.58-71.83h-21.87l27.17 104.52v60.78h22.09zm-56.67-95.08h-29.01v-50.19h32.69v-20.03h-54.79v165.3h22.1v-75.05h29.01v-20.03zm213.98-26.83-5.25 16.27-17.1-.03 13.85 10.03-5.32 16.25 13.82-10.08 13.82 10.08-5.32-16.25 13.85-10.03-17.1.03-5.25-16.27z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path882",
    d: "m382.08 148.44-36.93 17.06c-.42-.37-.88-.71-1.4-1.03l-1.95.9-1.1.51-1.95.9c-.15.99-.17 1.91-.04 2.76l-138.08 63.79c-.57-.65-1.28-1.24-2.13-1.76l-1.95.9-1.1.51-1.95.9c-.09.6-.14 1.18-.13 1.73l-36.93 17.06c-.39 2.35.43 4.13 2.48 5.36l36.93-17.06c.42.37.88.71 1.4 1.03l1.95-.9 1.1-.51 1.95-.9c.15-.99.17-1.91.04-2.76l138.08-63.79c.57.65 1.28 1.24 2.13 1.76l1.95-.9 1.1-.51 1.95-.9c.09-.6.14-1.18.13-1.73l36.93-17.06c.39-2.35-.43-4.13-2.48-5.36z",
    className: "st4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path884",
    d: "m158.94 148.44 36.93 17.06c.42-.37.88-.71 1.4-1.03l1.95.9 1.1.51 1.95.9c.15.99.17 1.91.04 2.76l138.08 63.79c.57-.65 1.28-1.24 2.13-1.76l1.95.9 1.1.51 1.95.9c.09.6.14 1.18.13 1.73l36.93 17.06c.39 2.35-.43 4.13-2.48 5.36l-36.93-17.06c-.42.37-.88.71-1.4 1.03l-1.95-.9-1.1-.51-1.95-.9c-.15-.99-.17-1.91-.04-2.76l-138.08-63.79c-.57.65-1.28 1.24-2.13 1.76l-1.95-.9-1.1-.51-1.95-.9c-.09-.6-.14-1.18-.13-1.73l-36.93-17.06c-.38-2.35.44-4.13 2.48-5.36z",
    className: "st4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path886",
    d: "M248.38 195.66c.7 1.9 1.03 3.33.6 5.35-3.98 18.69 7.14 29.12 19.16 30.31 12.45 1.23 25.88-7.47 24.53-27.22-.14-2.07.39-3.44 1.35-5.22 26.74-41.32-66.3-47.91-45.64-3.22zm9.36-4.94c-1.66-3.89-5.32-11.52.35-14.24 5.4-2.59 24.04-1.27 29.02 2.05 5.23 3.49.53 10.53-1.66 14.14-1.4 1.59-7.58-.93-13.89-1.38-6.27-.44-12.67 1.19-13.82-.57z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text888",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    transform: "translate(204.069 139.902)",
    "aria-label": "FYD CLUB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1442",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M13.209-20.431v4.304H6.975V0H2.226v-35.52H14v4.304H6.975v10.785z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1444",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M26.058 0h-4.75v-13.06l-5.837-22.46h4.7l3.562 15.435h.148l3.216-15.435h4.7l-5.74 22.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1446",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M34.498 0v-35.52h8.261q6.679 0 6.679 6.827v23.548Q49.438 0 43.748 0zm4.749-4.304h3.562q1.88 0 1.88-1.583v-22.756q0-2.573-2.127-2.573h-3.315z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1448",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M75.75-8.311v2.276Q75.75 0 70.06 0h-3.066q-5.69 0-5.69-6.035v-23.45q0-6.035 5.69-6.035h3.067q5.689 0 5.689 6.036v4.007H71v-3.661q0-2.078-2.126-2.078h-.94q-1.88 0-1.88 2.078v22.756q0 2.078 1.88 2.078h1.187q1.88 0 1.88-2.078V-8.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1450",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M90.706 0H79.427v-35.52h4.75v31.216h6.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1452",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M108.872-35.52v28.792q0 6.728-5.739 6.728h-4.007q-5.689 0-5.689-6.777V-35.52h4.75v28.891q0 2.325 2.077 2.325h1.93q1.929 0 1.929-2.325v-28.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1454",
    style: {
      fontSize: "49.47040176px",
      fontFamily: "BigNoodleTitling",
      fill: "#2c2c2c"
    },
    d: "M124.373-18.255q3.908 1.089 3.908 4.057v8.905Q128.281 0 122.89 0h-9.548v-35.52h8.113q6.333 0 6.333 6.431v6.827q0 3.067-3.414 3.76zM118.09-4.304h3.562q1.88 0 1.88-1.534v-7.865q0-2.523-2.82-2.523h-2.622zm0-16.226h2.227q2.72 0 2.72-2.573v-5.54q0-2.573-2.127-2.573h-2.82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFydLogo);
export default __webpack_public_path__ + "static/media/fyd_logo.73e3ae59c4b8966a87af36f5354cf4a6.svg";
export { ForwardRef as ReactComponent };